import { fn } from 'storybook/test';

import type { Meta, StoryFn } from '@storybook/react';
import type { NotificationProps } from './Notification';

import { Notification } from './Notification';

const codeString = `<Notification title={title} subtitle={subtitle} action={action} 
  level={level} variant={variant} onClose={() => {}} />`;

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Molecules/Notification',
  component: Notification,
  argTypes: {
    level: {
      options: ['neutral', 'information', 'success', 'warning', 'danger'],
      control: { type: 'radio' },
    },
    variant: {
      options: ['default', 'bar'],
      control: { type: 'radio' },
    },
  },
  parameters: {
    inspectComponent: Notification,
    codeString: codeString,
  },
} as Meta<NotificationProps>;

const Template: StoryFn<NotificationProps> = (args) => <Notification {...args} />;

const defaultArgs: Partial<NotificationProps> = {
  level: 'information',
  title: 'Titel van de melding',
  onClose: fn(),
};

export const NotificationExample = Template.bind({});
NotificationExample.args = {
  ...defaultArgs,
  variant: 'default',
  subtitle: 'Subtekst ter verduidelijking van de melding.',
  action: <span>Actie</span>,
};

export const AsBar = Template.bind({});
AsBar.args = {
  ...defaultArgs,
  variant: 'bar',
};
